//@ts-ignore
import { Link as RouterLink } from 'react-router-dom';

// material-ui
//@ts-ignore
import { Link, Stack, Typography } from '@mui/material';

// ==============================|| MAIN LAYOUT - FOOTER ||============================== //

const Footer = () => (
  <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: '24px 16px 0px', mt: 'auto' }}>
    {/* <Typography variant="caption">
      &copy; Developed by{' '}
      <Link component={RouterLink} to="https://felesys.com/" target="_blank" variant="caption" color="primary">
        Felesys Technologies Pvt. Ltd.
      </Link>
    </Typography> */}

    <Stack spacing={1.5} direction="row" justifyContent="space-between" alignItems="center">
      {/* <Link component={RouterLink} to="https://phoenixcoded.authordesk.app/" target="_blank" variant="caption" color="textPrimary">
        Support
      </Link> */}
    </Stack>
  </Stack>
);

export default Footer;
